import {IMapOffer} from "../../maps/types/IMapOffer";
import {IRelatedOfferList} from "../list/types/IOfferListResponse";

export const transformRelatedOfferIntoMapOffer = (offer: IRelatedOfferList): IMapOffer => ({
    id: offer.id,
    name: offer.name,
    coordinates: offer.geo_point.coordinates,
    vendorName: offer.vendor.name,
    vendorLogo: offer.vendor.logo?.v_log_80x60,
    description: `Liczba mieszkań: ${offer.properties}`,
    mainImage: {
        desktop: offer.main_image?.m_img_375x211 || undefined,
        mobile: offer.main_image?.m_img_155x87 || undefined
    },
    distance: offer.stats?.distance_from_region.distance,
    region: {
        country: offer.region.country
    }
});
import {IMapOffer} from "../../maps/types/IMapOffer";
import {IRelatedOfferList} from "../list/types/IOfferListResponse";

export const transformRelatedOfferIntoMapOffer = (offer: IRelatedOfferList): IMapOffer => ({
    id: offer.id,
    name: offer.name,
    coordinates: offer.geo_point.coordinates,
    vendorName: offer.vendor.name,
    vendorLogo: offer.vendor.logo?.v_log_80x60,
    description: `Liczba mieszkań: ${offer.properties}`,
    mainImage: {
        desktop: offer.main_image?.m_img_375x211 || undefined,
        mobile: offer.main_image?.m_img_155x87 || undefined
    },
    distance: offer.stats?.distance_from_region.distance,
    region: {
        country: offer.region.country
    }
});
